import * as React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { isNilOrEmpty } from 'packages/core'
import moment from 'moment'
import { MUIDatePicker, MUITimePicker } from 'packages/eid-ui/DateTimePickers'

export interface StartDateControlProps {
    selectedStartDate: any
    setSelectedStartDate: any
    disabled?: boolean
}

export const StartDateControl: React.FC<StartDateControlProps> = ({
    selectedStartDate,
    setSelectedStartDate,
    disabled = false,
}) => {
    const { t } = useTranslation()

    return (
        <Box display="flex" style={{ opacity: disabled ? '.5' : '1' }}>
            <MUIDatePicker
                dateFormat="L"
                //@ts-ignore
                minDate={moment(new Date())}
                value={selectedStartDate.local()}
                handleChange={(e: any) => {
                    let date = moment()
                    if (!isNilOrEmpty(e)) {
                        date = moment(e)
                    }
                    const dateToSet = date.clone()
                    const isFuture = date.diff(moment()) > 0
                    if (isFuture) {
                        dateToSet.startOf('day')
                    } else {
                        const now = moment()
                        dateToSet.set({
                            hour: now.hour(),
                            minute: now.minute(),
                            second: 0,
                        })
                    }
                    setSelectedStartDate(dateToSet)
                }}
                disabled={disabled}
                label={t('Common_StartDate')}
                fieldProps={{ sx: { width: '50%' } }}
            ></MUIDatePicker>
            <MUITimePicker
                value={selectedStartDate.local()}
                handleChange={(e: any) => {
                    const time = moment(e, 'HH:mm')
                    const dateToSet = selectedStartDate

                    dateToSet.set({
                        hour: time.hour(),
                        minute: time.minute(),
                        second: 0,
                    })

                    setSelectedStartDate(dateToSet)
                }}
                disabled={disabled}
                label={t('Common_StartTime')}
                timeFormat="LT"
                fieldProps={{ sx: { width: '50%' } }}
            ></MUITimePicker>
        </Box>
    )
}
